import { render, staticRenderFns } from "./asianPreCup_index.vue?vue&type=template&id=783169a1&scoped=true"
import script from "./asianPreCup_index.vue?vue&type=script&lang=js"
export * from "./asianPreCup_index.vue?vue&type=script&lang=js"
import style0 from "./asianPreCup_index.vue?vue&type=style&index=0&id=783169a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783169a1",
  null
  
)

export default component.exports